<template>
  <reward-result-modal
    :visible="store.visible"
    :items="store.items"
    :title="store.title"
    confirm-text="收下奖励"
    :close-on-mask="true"
    @update:visible="onVisibleChange"
    @confirm="onConfirm"
    @close="onConfirm"
  />
</template>

<script setup>
import { useLuckyDropStore } from '@/store/luckyDrop'

const store = useLuckyDropStore()

function onConfirm() {
  store.dismiss()
}

function onVisibleChange(v) {
  if (!v && store.visible) {
    store.dismiss()
  }
}
</script>

<style scoped>
:deep(.reward-mask) {
  z-index: 100000;
}
</style>
